import client from '../httpClient';

// customer013
const customerRegisterApi = (params) => {
  return client.post('/customers/', params);
};

export default customerRegisterApi;
